import { CategoryType } from "@/types/poiCard";

// 商品卡片的供给类型标签的样式类
export const ProductTagStyleClassMap: Record<CategoryType, string> = {
  [CategoryType.WAIMAI]: "category-tag-waimai",
  // [PRODUCT_CATEGORY_TYPE.GROUP]: "category-tag-group",
  // [PRODUCT_CATEGORY_TYPE.MEDICINE]: "category-tag-medicine",
};


// 埋点相关参数枚举
export enum PoiCouponBuType {
  WAIMAI = 1, // 外卖
  DAO_CAN = 2, // 到餐
  DAO_ZONG = 3, // 到综
}

export enum PoiCouponRecallStatus {
  HAS_COUPON = 1, // 有券
  NO_COUPON = 2, // 无券
}

export enum PoiCardClickPosition {
  POI = 0, // 其它区域
  SKU = 1, // 菜品
  COUPON = 3, // 下挂券
}
